import axios from 'axios';
import { getCookie } from '../helper/_cookieHelper.js';

export const getToken = () => {
    const token = getCookie('token');
    return token;
};

axios.defaults.baseURL =
    process.env.REACT_APP_NODE_ENV === 'production'
        ? `https://vserve-api.valet2you.in/`
        : `https://test-vserve-api.valet2you.in/`;

axios.defaults.headers.common['Accept'] = 'application/json, text/plain, */*';
axios.defaults.headers.post['Content-Type'] = 'application/json';

// Add a request interceptor
axios.interceptors.request.use(
    function (config) {
        const token = getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

// Add a response interceptor
axios.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (error.response?.status === 401) {
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export const loginUser = (data) => {
    // Remove any existing token
    delete axios.defaults.headers.common['Authorization'];
    return axios.post(`api/v5.0.1/login`, data);
};

export const logoutUser = () => {
    return axios.get(`api/v5.0.1/logout`);
};

export const getHotelsList = () => {
    return axios.get('api/v5.0.1/restaurant_server/global-supervisor/hotels');
};

export const getOutletsList = () => {
    return axios.get('api/v5.0.1/restaurant_server/global-supervisor/restaurants');
};

export const getAnalyticsData = (payload) => {
    return axios.get('api/v5.0.1/restaurant_server/global-supervisor/analytics', {
        params: payload
    });
};